import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation createOrganization($data: createOrganizationInput!) {
    createOrganization(data: $data) {
      id
      status
      error {
        statusCode
        message
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const createOrganizationRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.CreateOrganizationInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/create_organization',
  async (
  params: {data: TYPES.CreateOrganizationInput;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.createOrganization;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const createOrganizationSlice = createSlice({
  name: 'create_organization',
  initialState: initialState,
  reducers: {
    createOrganizationClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(createOrganizationRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(createOrganizationRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(createOrganizationRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { createOrganizationClear } = createOrganizationSlice.actions;

export const createOrganization = createSelector(
  (state: RootState) => state.organization.createOrganization.result,
  (state: RootState) => state.organization.createOrganization.error,
  (state: RootState) => state.organization.createOrganization.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default createOrganizationSlice.reducer;